// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1_0xZ","colMaxWidth":"Table_colMaxWidth__2Kvf1"};